import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { configureStore, history } from 'helpers';
import { App } from 'components';
import { INITIAL_APP_STATE, LINKING_SERVICE } from './constants/common.constants';
import LinkingService from './services/linking.services';
import { logout } from './actions/login.actions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/xomepro-mobile-fonts.scss';
import 'assets/sass/style.scss';
import axios from 'axios';
import _ from 'lodash';

const store = configureStore(INITIAL_APP_STATE);
const envResponse = axios.get('/env_config/config.json');
const headers = {
  'X-RED-APIKey': _.get(envResponse, 'data.contactsApiKey', ''),
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`
};

axios.interceptors.response.use(response => {
  return response;
},
  error => {
    if (axios.isCancel(error)) {
      console.warn(`A Request has been cancelled by a new request ${error.message}`);
      return;
    }
    const originalRequest = error.config;
    const errCode = _.get(error.response, 'status', []);

    if (errCode === 401 && error.config.url.includes('/login')) {
      if (!error.config.data.includes('azureB2CToken'))
        store.dispatch(logout());
    }

    if (errCode === 401 && !originalRequest._retry && !error.config.url.includes('/login')) {
      originalRequest._retry = true;
      axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;

      return refreshSaveToken()
        .then((data) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.accessToken;
          originalRequest.headers['Authorization'] = 'Bearer ' + data.accessToken;
          return axios(originalRequest);
        });
    }
    return Promise.reject(error);
  });

const refreshSaveToken = async () => {
  const storedDeviceData = localStorage.getItem('clientDeviceInfo');
  const { deviceId = '', deviceType = null, appVersion = '' } = !storedDeviceData ? {} : JSON.parse(storedDeviceData);
  const response = await axios.request(
    {
      baseURL: (await envResponse).data.contactsApiUrl,
      url: '/login',
      method: 'POST',
      headers: headers,
      data: {
        refreshToken: localStorage.getItem('refreshToken'),
        clientDeviceInfo: { deviceId, deviceType, appVersion }
      }
    });

  const { accessToken, memberResource, expiryDate, refreshToken } = response.data;
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('memberResource', memberResource);
  localStorage.setItem('accessTokenExpiryDate', expiryDate);
  localStorage.setItem('refreshToken', refreshToken);
  return response.data;
};

LinkingService.addEventListeners(store);
LinkingService.sendDataToWrapper({ type: LINKING_SERVICE.ADDED_LISTENER });

const container = document.getElementById('crm-ui-app');
const root = createRoot(container);

export const renderApp = () => {
  root.render(
    <Provider store={store}>
      <App history={history} />
      <ToastContainer
        position="top-center"
        className="toast-container"
        draggable={false}
        hideProgressBar
        closeButton={false}
      />
    </Provider>
  );
};

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(function (registration) {
        console.info('Registration successful, scope is:', registration.scope);
      })
      .catch(function (error) {
        console.error('Service worker registration failed, error:', error);
      });
  });
} else {
  console.error('Service worker not supported');
}

renderApp();

if (module.hot) {
  module.hot.accept('components/app', () => { renderApp(); });
}
